import React from "react";
import Navbar from "../NavBar/Navbar";
import ContactUs from "./ContactUs";
import Footer from "../Footer/Footer";

const ContactUsMain = () => {
  return (
    <main>
        <Navbar />
        <ContactUs/>
        <Footer/>
    </main>
  );
};


export default ContactUsMain;